/** Compact display for investment amounts: 1.5M, 250k, etc. */
export const formatCompactAmount = (amount: number): string => {
  if (amount >= 1_000_000) {
    return `${(amount / 1_000_000).toFixed(1).replace(/\.0$/, '')}M`;
  }
  if (amount >= 1_000) {
    return `${(amount / 1_000).toFixed(1).replace(/\.0$/, '')}k`;
  }
  return amount.toString();
};

/** Startup seeking line, e.g. "Seeking: 1M USD" */
export const formatSeekingInvestment = (amount: number, currency: string): string =>
  `Seeking: ${formatCompactAmount(amount)} ${currency}`;
